import styled, { css } from "styled-components/native";
import { themes } from "../../design/colors";
import {
  Feather as IconsFE,
  FontAwesome5 as IconsFA5,
} from "@expo/vector-icons";

interface CardRoutesProps {
  first: boolean;
}

export const CardLatestDeliveries = styled.View<CardRoutesProps>`
    background: ${themes.colors.white};
    border-radius: 10px;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px;
    shadow-color: ${themes.colors.black};
    shadow-opacity: 0.23px;
    shadow-radius: 5px;
    elevation: 1px;
    margin-bottom: 20px;
    ${(props) =>
      props.first &&
      css`
      margin-top: ${props.first ? 30 : 10}px;
      `}
`;

export const IconContainer = styled.View`
    background: ${themes.colors.blue0};
    padding: 10px;
    align-self: center;
    border-radius: 10px;
`;

export const IconContainerAction = styled.TouchableOpacity`
    padding: 10px;
    align-self: center;
    border-radius: 10px;
`;

export const IconFE = styled(IconsFE)`
  color: ${themes.colors.red1};
`;

export const IconFA5 = styled(IconsFA5)`
  color: ${themes.colors.primary};
`;

export const ContainerDescription = styled.View`
    padding: 0 15px;
    flex: 1;
    justify-self: flex-start;
    align-self: center;
`;

export const Title = styled.Text`
    font-weight: bold;
    font-size: 18px;
`;

export const Subtitle = styled.Text`
    color: ${themes.colors.gray1};
`;